import React from "react";
import Layout from "./layout/Layout";
import "react-multi-carousel/lib/styles.css";

export default function App() {
  return (
    <div>
      <Layout />
    </div>
  );
}
